<canvas #funnel [attr.id]="id"></canvas>
